import { getGenericFormInitialValues } from "../../../components/form/utils/initialValues";
import { BENEFIT_TYPE } from "../../../../../../constant/coverages";
import { PLAN_MARKETS } from "../../../../../../constant/planMarkets";

const INSURANCE_TYPE = { MEDICAL: "MEDICAL", PRESCRIPTION: "PRESCRIPTION", BOTH: "BOTH" };

// insurance.type is prefilled by the backend with the patient's primary-coverage benefit type
// (medical | prescription | medical_and_prescription); translate it to the form's option.
const BENEFIT_TYPE_TO_INSURANCE_TYPE = {
  [BENEFIT_TYPE.MEDICAL]: INSURANCE_TYPE.MEDICAL,
  [BENEFIT_TYPE.PRESCRIPTION]: INSURANCE_TYPE.PRESCRIPTION,
  [BENEFIT_TYPE.MEDICAL_AND_PRESCRIPTION]: INSURANCE_TYPE.BOTH
};

const clearMedical = (insurance) => {
  insurance.medicalPayer = null;
  insurance.medicalMemberId = null;
};

const clearPrescription = (insurance) => {
  insurance.rxPlanName = null;
  insurance.rxBin = null;
  insurance.rxPcn = null;
  insurance.rxGroup = null;
};

export const getGskCopayFormInitialValues = ({ applicationForm, formJson }) => {
  const baseValues = getGenericFormInitialValues(applicationForm, formJson);
  const insurance = { ...baseValues.insurance };

  // A saved draft already holds a form value (MEDICAL/PRESCRIPTION/BOTH), which isn't a benefitType key, so it
  // passes through unchanged.
  insurance.type = BENEFIT_TYPE_TO_INSURANCE_TYPE[insurance.type] ?? insurance.type ?? null;

  // GSK copay only enrolls commercial insurance. insurance.primaryPlanMarket is a non-rendered helper the
  // backend prefills with the primary coverage's plan market (present only on a fresh prefill; a saved draft
  // carries none). If the primary coverage isn't commercial, prefill no insurance at all.
  const primaryPlanMarket = applicationForm?.formData?.insurance?.primaryPlanMarket;
  if (primaryPlanMarket && primaryPlanMarket !== PLAN_MARKETS.Commercial) {
    insurance.type = null;
    clearMedical(insurance);
    clearPrescription(insurance);
    return { ...baseValues, insurance };
  }

  // Align the prefilled fields to the resolved type so the autofill's medical/prescription spread isn't carried
  // into a group the type excludes (e.g. a commercial prescription-only patient: clear the medical fields).
  const { type } = insurance;
  if (type !== INSURANCE_TYPE.MEDICAL && type !== INSURANCE_TYPE.BOTH) clearMedical(insurance);
  if (type !== INSURANCE_TYPE.PRESCRIPTION && type !== INSURANCE_TYPE.BOTH) clearPrescription(insurance);

  // The field "Preferred Language (if other than English)" has no English entry by design.
  // When the MPD sends "english" (or getPreferredLanguage resolves it to code "en"),
  // clear the value so the field starts blank rather than showing a mismatched/invisible selection.
  const patient = { ...baseValues.patient };
  const prefLang = patient.preferredLanguage;
  if (prefLang && (prefLang.toLowerCase() === "english" || prefLang.toLowerCase() === "en")) {
    patient.preferredLanguage = null;
  }

  return { ...baseValues, insurance, patient };
};
